import { AxiosInstance } from "axios";
import { AirQueryParams } from "./query.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";

/** Unwrap axios response body (Qubictron returns JSON directly). */
export const mutateAirMetadataInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use((response) => response.data);
};

type CreateAirSearchQueryParamsParams = {
  model?: {
    reference?: string | null;
  };
  requestType: "openedCard" | "search" | "updateCard";
  override?: Partial<AirQueryParams>;
};

export const createAirSearchQueryParams = ({
  model,
  requestType,
  override,
}: CreateAirSearchQueryParamsParams): AirQueryParams | null => {
  const awbNumber: Nullable<SearchReferenceDTO> = override?.awb_number ?? model?.reference;

  if (!awbNumber) return null;

  switch (requestType) {
    case "openedCard":
    case "updateCard":
    case "search":
    default:
      return {
        awb_number: awbNumber,
        route_path: override?.route_path ?? true,
      };
  }
};
